import React from 'react';
import './AMS.css';
import FMSimage from '../Assets/ams.jpg'; // First image (full size)
import FMSimage2 from '../Assets/ams2.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/ams3.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/ams4.jpeg'; // Image for Why Choose section
import FMSimage5 from '../Assets/ams5.jpeg'; // Image for Industries section

const AMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">Asset Monitoring System</h1>
                    <p className="FMS-description">
                        An Asset Monitoring System is designed to manage and track assets, inventory, and personnel efficiently, providing real-time data, reducing losses, and improving management processes. This system typically involves hardware sensors, software platforms, and wireless communication technologies that integrate to track assets, monitor movement, and generate reports for analysis.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Asset Monitoring System" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Asset Monitoring System provides real-time tracking of assets and inventory, with automated alerts for unauthorized access or movement. Access the system remotely from any device and receive detailed reports to optimize operational efficiency. It also ensures data security and regulatory compliance.
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Advanced Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        The system utilizes advanced sensors to continuously track assets and personnel. Data is transmitted wirelessly to a centralized platform, where it is processed and displayed in an intuitive dashboard. Alerts for unusual activity, such as unauthorized movement, ensure proactive management. Reports and analytics provide actionable insights to help businesses save costs and improve efficiency.
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Asset Monitoring System</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Asset Monitoring System stands out due to its precision, reliability, and user-friendly design. It minimizes operational costs, prevents unauthorized access, and enhances overall efficiency with its robust analytics and real-time updates. By choosing our solution, you benefit from:
                        <ul>
                            <li>Accurate and reliable asset tracking</li>
                            <li>Seamless integration with existing systems</li>
                            <li>Customizable alerts and reporting</li>
                            <li>Enhanced security and loss prevention</li>
                            <li>Easy installation and minimal maintenance</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our System */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our Asset Monitoring System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using Asset Monitoring System" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Asset Monitoring System is trusted by a variety of industries to optimize asset management and enhance operational efficiency. These industries rely on our solution for its accuracy, reliability, and cost-saving benefits:
                        <ul>
                            <li>Logistics & Supply Chain</li>
                            <li>Retail & Inventory Management</li>
                            <li>Smart Cities</li>
                            <li>Industrial Asset Tracking</li>
                            <li>Residential & Commercial Buildings</li>
                            <li>Healthcare & Pharmaceuticals</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AMS;
